import {createReducer} from "redux-act";
import {
	IArticles,
	ICountry,
	IFanVoteRanking,
	IJSONReducer,
	IPlayer,
	IReducerAction,
	ISettings,
	ISquad,
} from "modules/types";
import {
	fetchArticles,
	fetchArticlesFailed,
	fetchArticlesSuccess,
	fetchCountriesSuccess,
	fetchFanVoteRankings,
	fetchFanVoteRankingsFailed,
	fetchFanVoteRankingsSuccess,
	fetchPlayers,
	fetchPlayersFailed,
	fetchPlayersSuccess,
	fetchSettings,
	fetchSettingsFailed,
	fetchSettingsSuccess,
	fetchSquads,
	fetchSquadsFailed,
	fetchSquadsSuccess,
} from "modules/actions";
import {RequestStateType} from "modules/enums";

const initialState: IJSONReducer = {
	players: [],
	playersRequestState: RequestStateType.Idle,
	squads: [],
	squadsRequestState: RequestStateType.Idle,
	countries: [],
	articlesRequestState: RequestStateType.Idle,
	articles: {},
	settingsRequestState: RequestStateType.Idle,
	settings: {
		votingPeriodStatus: null,
		landingBannerUrl: null,
		confirmationBannerUrl: null,
	},
	playerStatsHistoryRequestState: RequestStateType.Idle,
	playerStatsHistory: null,
	fanVoteRankingsRequestState: RequestStateType.Idle,
	fanVoteRankings: [],
};

type IJSONReducerPayload<TP = null> = IReducerAction<IJSONReducer, TP>;

const onPlayersFetch: IJSONReducerPayload = (state) => ({
	...state,
	playersRequestState: RequestStateType.Loading,
});

const onPlayersFetchSuccess: IJSONReducerPayload<IPlayer[]> = (state, payload) => ({
	...state,
	players: payload,
	playersRequestState: RequestStateType.Success,
});

const onPlayersFetchFailed: IJSONReducerPayload = (state) => ({
	...state,
	playersRequestState: RequestStateType.Error,
});

const onFetchSquads: IJSONReducerPayload = (state) => ({
	...state,
	squadsRequestState: RequestStateType.Loading,
});

const onFetchSquadsSuccess: IJSONReducerPayload<ISquad[]> = (state, payload) => ({
	...state,
	squads: payload,
	squadsRequestState: RequestStateType.Success,
});

const onFetchSquadsFailed: IJSONReducerPayload = (state) => ({
	...state,
	squadsRequestState: RequestStateType.Error,
});

const onFetchSettings: IJSONReducerPayload = (state) => ({
	...state,
	settingsRequestState: RequestStateType.Loading,
});

const onFetchSettingsSuccess: IJSONReducerPayload<ISettings> = (state, payload) => ({
	...state,
	settings: payload,
	settingsRequestState: RequestStateType.Success,
});

const onFetchSettingsFailed: IJSONReducerPayload = (state) => ({
	...state,
	settingsRequestState: RequestStateType.Error,
});

const onFetchCountriesSuccess: IJSONReducerPayload<ICountry[]> = (state, payload) => ({
	...state,
	countries: payload,
});

const onFetchFanVoteRankings: IJSONReducerPayload = (state) => ({
	...state,
	fanVoteRankingsRequestState: RequestStateType.Loading,
});

const onFetchFanVoteRankingsSuccess: IJSONReducerPayload<IFanVoteRanking[]> = (state, payload) => ({
	...state,
	fanVoteRankings: payload,
	fanVoteRankingsRequestState: RequestStateType.Success,
});

const onFetchFanVoteRankingsFailed: IJSONReducerPayload = (state) => ({
	...state,
	fanVoteRankingsRequestState: RequestStateType.Error,
});

const onFetchArticles: IJSONReducerPayload = (state) => ({
	...state,
	articlesRequestState: RequestStateType.Loading,
});

const onFetchArticlesSuccess: IJSONReducerPayload<IArticles> = (state, payload) => ({
	...state,
	articles: payload,
	articlesRequestState: RequestStateType.Loading,
});

const onFetchArticlesFailed: IJSONReducerPayload = (state) => ({
	...state,
	articlesRequestState: RequestStateType.Error,
});

export const jsonReducer = createReducer({}, initialState)
	.on(fetchPlayers, onPlayersFetch)
	.on(fetchPlayersSuccess, onPlayersFetchSuccess)
	.on(fetchPlayersFailed, onPlayersFetchFailed)
	.on(fetchSquads, onFetchSquads)
	.on(fetchSquadsSuccess, onFetchSquadsSuccess)
	.on(fetchSquadsFailed, onFetchSquadsFailed)
	.on(fetchSettings, onFetchSettings)
	.on(fetchSettingsSuccess, onFetchSettingsSuccess)
	.on(fetchSettingsFailed, onFetchSettingsFailed)
	.on(fetchCountriesSuccess, onFetchCountriesSuccess)
	.on(fetchFanVoteRankings, onFetchFanVoteRankings)
	.on(fetchFanVoteRankingsSuccess, onFetchFanVoteRankingsSuccess)
	.on(fetchFanVoteRankingsFailed, onFetchFanVoteRankingsFailed)
	.on(fetchArticles, onFetchArticles)
	.on(fetchArticlesSuccess, onFetchArticlesSuccess)
	.on(fetchArticlesFailed, onFetchArticlesFailed);
